import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

// User selectors
export const selectUser = (state: RootState) => state.auth.user;

export const selectUserSlice = (state: RootState) => state.auth;

// Memoized selectors
export const selectLeaseIds = createSelector(
  [selectUser],
  (user) => {
    if (!user) return [];
    
    const leaseId = user.leaseId ? [user.leaseId] : [];
    const additional = (user.leaseIds as number[] | undefined) || [];
    return Array.from(new Set<number>([...leaseId, ...additional].filter(Boolean) as number[]));
  }
);

export const isUserLeaseHolder = createSelector(
  [selectUser],
  (user) => Boolean(user?.leaseId)
);
